export default interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

export enum ToastType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARN = 'WARN',
}
